(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("QierPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["QierPlayer"] = factory();
	else
		root["QierPlayer"] = factory();
})(this, function() {
return 